<template>
  <v-form v-model="valid" style="font-family:Microsoft JhengHei;">
    <v-container>
      <v-card>
        <v-container>
          <v-row dense>
            <v-col cols="12" md="12">
                <h4>{{targetItem.deptName}}</h4>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" md="6">
                案件編號：{{targetItem.caseNo}}<br/>
                語言別：{{targetItem.language}}<br/>
                需求時間：{{convertDBDateToString(targetItem.serviceDate)}}<br/>
                開始時間：{{targetItem.estimatedServiceStartTime}}<br/>
                預計時數：{{targetItem.estimatedHours}}小時<br/>
                服務地點：{{targetItem.serviceDistrict}}{{targetItem.serviceAddress}}<br/>

                案件類型：{{targetItem.caseType}}<br/>
                案件敘述：{{targetItem.caseNote}}<br/>
                計費方式：{{targetItem.feeType}}<br/>
                回覆期限：{{getDateFormat(targetItem.responseDueDate,"yyyy-MM-dd HH:mm",true)}}<br/>
                
                聯絡人：{{targetItem.contactName}}<br/>
                聯絡電話：{{targetItem.contactHomeTel}}<br/>
                行動電話：{{targetItem.contactMobileTel}}<br/>
                <div v-if="targetItem.status =='C05'">
                  取消時間：{{getDateFormat(targetItem.cancelDate,"yyyy-MM-dd HH:mm",true)}}<br/>
                  取消原因：{{targetItem.cancelCaseReason}}<br/>
                </div>
                <div v-if="targetItem.status =='C06'">
                  通譯取消時間：{{getDateFormat(detailItem.cancelDate,"yyyy-MM-dd HH:mm",true)}}<br/>
                  通譯取消原因：{{detailItem.cancelReason}}<br/>
                </div>
            </v-col>
            <v-col cols="12" md="6"  v-if="targetItem.status =='C01'">
                <h4>服務意願統計</h4><br/>
                <v-chip :color="getColor('I01')" label dark large>可以服務：{{getIpLength('I01')}}位</v-chip><br/><br/>
                <v-chip :color="getColor('I02')" label dark large >無法服務：{{getIpLength('I02')}}位</v-chip><br/><br/>
                <v-chip :color="getColor('I00')" label dark large >等待回覆：{{getIpLength('I00')}}位</v-chip><br/><br/>
            </v-col>
          </v-row>
          <v-row justify="center" v-if=" userProfile.memberAccount.type == 'AAA' && (targetItem.status=='C01' || targetItem.status=='C02' || targetItem.status=='C03' || targetItem.status=='C07' ) ">
            <v-col cols="4" >
              <v-btn
                dark
                width="100%"
                color="black"
                class="ma-2"
                @click="cancelCase"
              >
                取消案件
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
      <v-row>
        <v-col cols="12" md="10">
          <v-data-iterator :items="ipArray" hide-default-footer no-data-text="查無資料">
            <template v-slot:default="props">
              <v-row>
                <v-col v-for="(item,i) in props.items" :key="i" cols="12" sm="5" md="5" lg="6">
                  <v-card>
                    <v-card-title v-bind:class="{'red white--text':isItemExist(item.caseDetail)}">
                      <!-- <h1 v-if="selectedArray.indexOf(item) ==-1">{{ item.name }}</h1> -->

                      <h3>{{ item.name }}</h3>
                      <h4>（{{item.gender=='M'?'男':'女'}}） 案件數：{{item.caseCount}}</h4>

                      <v-spacer />
                      <v-rating
                        readonly
                        v-model="item.score"
                        color="yellow darken-3"
                        background-color="grey darken-1"
                        empty-icon="$ratingFull"
                        half-increments
                        hover
                      ></v-rating>
                      <v-btn @click="dialog = !dialog;memberItem = item;" class="ma-1">
                        <v-icon>search</v-icon>
                      </v-btn>
                      <!-- <div v-for="(detail,j) in targetItem.interpreterCaseDetails" :key="j"> -->
                      <v-btn
                        @click="selectedArrayPushObject(item.caseDetail);"
                        v-if="item.caseDetail.status=='I01' && 
                           !isItemExist(item.caseDetail)"
                        class="ma-1"
                      >
                        <v-icon>mdi-account-plus</v-icon>
                      </v-btn>
                      <v-btn
                        @click="selectedArray.splice(findItemIndex(item.caseDetail),1)"
                        v-if="item.caseDetail.status=='I01' && 
                        isItemExist(item.caseDetail)"
                        class="ma-1"
                      >
                        <v-icon>mdi-account-remove</v-icon>
                      </v-btn>
                      <v-chip
                        class="ma-2"
                        :color="getColor(item.caseDetail.status)"
                        label
                        dark
                      >{{convertIpStatusToWord(item.caseDetail.status)}}</v-chip>
                      <!-- </div> -->
                    </v-card-title>
                    <v-spacer></v-spacer>
                    <v-list dense>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.nationality }}</v-list-item-content>
                          </template>
                          <span>原屬國籍</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.qualificationInTaiwan }}</v-list-item-content>
                          </template>
                          <span>在臺資格與取得證件</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ convertDBDateToString(item.serviceStartDate) }}</v-list-item-content>
                          </template>
                          <span>開始從事通譯服務時間</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.educationLevel }}</v-list-item-content>
                          </template>
                          <span>教育程度</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content class="align-end" v-on="on">{{ item.serviceType }}</v-list-item-content>
                          </template>
                          <span>服務類型</span>
                        </v-tooltip>
                      </v-list-item>
                      <v-list-item>
                        <v-tooltip left>
                          <template v-slot:activator="{ on }">
                            <v-list-item-content
                              class="align-end"
                              v-on="on"
                            >{{ item.serviceLanguage }}</v-list-item-content>
                          </template>
                          <span>熟悉語言</span>
                        </v-tooltip>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-col>
        <v-col cols="12" md="2">
          <v-card v-show="selectedArray.length != 0">
            <v-card-title>
              <h1>已選擇：{{selectedArray.length}}</h1>
            </v-card-title>
            <v-card-text v-for="(selectedItem,j) in selectedArray" :key="j">
              <h3>
                {{selectedItem.memberName}}
                <v-btn fab x-small @click="selectedArray.splice(j,1)">
                  <v-icon>mdi-account-remove</v-icon>
                </v-btn>
              </h3>
            </v-card-text>
            <v-card-actions>
              <v-btn color="red" block @click.prevent="submitObject">
                <font style="color:white">確認</font>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <v-dialog v-model="dialog" width="800px" v-if="dialog">
      <InterpreterDetail
        :memberItem="memberItem"
        :caseItem="targetItem"
        v-on:childDialog="parentDialog"
      ></InterpreterDetail>
    </v-dialog>
  </v-form>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import InterpreterDetail from "../Common/InterpreterDetail";
import Vue from "vue";
let msgServer;

export default {
  components: {
    InterpreterDetail
  },
  computed: {
    ...mapGetters({
      getTargetCaseId: ["getTargetCaseId"],
      idbServerUrl: ["getIdbServerUrl"]
    })
  },
  data() {
    return {
      valid: false,
      dialog: false,
      targetItem: {},
      memberItem: {},
      ipArray: [],
      selectedArray: [],
      cancelReason: "",
      detailItem: {},
      userProfile: JSON.parse(this.$localStorage.get("userProfileStr"))
    };
  },
  methods: {
    ...mapActions(["updateTargetCaseId"]),
    findSelectedIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.selectedArray.find(function(element, index) {
        if (item.caseId == element.caseId) itemIndex = index;
      });
      return itemIndex;
    },
    getIpLength(status) {
      if (this.targetItem.interpreterCaseDetails != null)
        return this.targetItem.interpreterCaseDetails.filter(detail => {
          return detail.status == status;
        }).length;
    },
    selectedArrayPushObject(item) {
      let vm = this;
      if (vm.selectedArray.length != 0) {
        vm.alertSwalUtil();
        return;
      }
      let selectedFlag = vm.selectedArray.some(function(element) {
        return element.memberId == item.memberId;
      });
      if (!selectedFlag) {
        vm.selectedArray.push(item);
        vm.addAlertUtil();
      }
    },
    parentDialog() {
      this.dialog = !this.dialog;
    },
    getColor(value) {
      //   console.log("value " + value);
      if (value == "I00") {
        return "#43A047";
      } else if (value == "I01") {
        return "#1976D2";
      } else if (value == "I02") {
        return "#FFC107";
      } else if (value == "I03") {
        return "#311B92";
      } else if (value == "I04") {
        return "#1976D2";
      } else if (value == "I05") {
        return "#EF6C00";
      } else if (value == "I06") {
        return "#AA00FF";
      } else if (value == "I07") {
        return "#00BCD4";
      } else if (value == "I08") {
        return "#00BCD4";
      } else if (value == "I09") {
        return "#00BCD4";
      } else if (value == "I10") {
        return "#EF5350";
      }
    },
    isItemExist(item) {
      let vm = this;
      return vm.selectedArray.some(function(element) {
        return item.memberId == element.memberId;
      });
    },
    findItemIndex(item) {
      let vm = this;
      let itemIndex = 0;
      vm.selectedArray.find(function(element, index) {
        if (item.memberId == element.memberId) itemIndex = index;
      });
      return itemIndex;
    },
    cancelCase() {
      let vm = this;
      vm.submitCancelUtil().then(function(result) {
        if (result === true) {
          vm.targetItem.status = "C05";
          vm.targetItem.cancelCaseReason = vm.cancelReason;
          vm.targetItem.cancelDate = new Date();
          var detailList = vm.targetItem.interpreterCaseDetails;
          delete vm.targetItem.interpreterCaseDetails;
          let caseBean = {
            ic: vm.targetItem,
            detailList: detailList
          };
          vm.axios
            .put(vm.idbServerUrl + "idb/interpreterCase/", caseBean, {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            })
            .then(function() {
              vm.successSwalUtil();
              vm.$router.push({
                path: "/caseList"
              });
            })
            .catch(function(error) {
              vm.handErrorUtil(error);
              console.log("!!!! " + error);
            });
        }
      });
    },
    submitObject() {
      let vm = this;
      vm.submitConfirmUtil().then(function(result) {
        if (result == true) {
          let caseStatus = "C02";
          vm.selectedArray.forEach(function(detail) {
            detail.status = "I03";
            vm.axios
              .put(
                vm.idbServerUrl + "idb/interpreterCaseDetail/" + caseStatus,
                detail,
                {
                  headers: {
                    "Content-Type": "application/json",
                    Authorization: vm.$localStorage.get("idb_login_token")
                  }
                }
              )
              .then(function(response) {
                console.log("response " + JSON.stringify(response));
                vm.successSwalUtil();
              })
              .catch(function(error) {
                vm.handErrorUtil(error);
                console.log("!!!! " + error);
              });
          });

          vm.targetItem.interpreterCaseDetails.forEach(detail => {
            let pass = vm.selectedArray.some(element => {
              return detail.caseDetailId == element.caseDetailId;
            });
            if (!pass) {
              let caseStatus = "C02";
              detail.status = "I06";
              vm.axios
                .put(
                  vm.idbServerUrl + "idb/interpreterCaseDetail/" + caseStatus,
                  detail,
                  {
                    headers: {
                      "Content-Type": "application/json",
                      Authorization: vm.$localStorage.get("idb_login_token")
                    }
                  }
                )
                .then(function(response) {
                  console.log("response " + JSON.stringify(response));
                  vm.successSwalUtil();
                })
                .catch(function(error) {
                  vm.handErrorUtil(error);
                  console.log("!!!! " + error);
                });
            }
          });
          vm.$router.push({
            path: "/caseList"
          });
        } else if (result == "cancel") {
          console.log(" CANCEL!!!!!!!!!!!! ");
        }
      });
    }
  },
  mounted() {
    let vm = this;
    console.log(vm.getTargetCaseId);
    vm.axios
      .get(vm.idbServerUrl + "idb/interpreterCase/" + vm.getTargetCaseId, {
        headers: {
          "Content-Type": "application/json",
          Authorization: vm.$localStorage.get("idb_login_token")
        }
      })
      .then(function(response) {
        // let dataResponse = JSON.stringify(response.data);
        //console.log("AAAA \n" + JSON.stringify(response.data));
        vm.targetItem = response.data;

        let newinterpreterCaseDetails = [];
        if (
          vm.userProfile.memberAccount.type == "BBB" &&
          vm.targetItem.interpreterCaseDetails != null
        ) {
          vm.targetItem.interpreterCaseDetails.forEach(element => {
            if (
              element.memberDeptId == vm.userProfile.memberAccount.mainDeptId
            ) {
              newinterpreterCaseDetails.push(element);
            }
          });
          if (newinterpreterCaseDetails != null) {
            vm.targetItem.interpreterCaseDetails = newinterpreterCaseDetails;
          }
        }
        //console.log("DDD \n" + JSON.stringify(newinterpreterCaseDetails));
        //找到通譯取消
        if (vm.targetItem.interpreterCaseDetails != null)
          vm.detailItem = vm.targetItem.interpreterCaseDetails.find(element => {
            return element.status == "I05";
          });

        let queryObjectStr = JSON.stringify({});

        let queryPagerStr = JSON.stringify({
          pageSize: -1
        });
        let memberIdArray = [];
        if (vm.targetItem.interpreterCaseDetails != null)
          vm.targetItem.interpreterCaseDetails.forEach(element => {
            memberIdArray.push({
              propertyName: "uuid",
              value: element.memberId
            });
          });
        let criterionStr = JSON.stringify({
          in: memberIdArray
        });
        vm.axios
          .get(
            vm.idbServerUrl +
              "idb/member/memberAccount?queryString=" +
              encodeURIComponent(queryObjectStr) +
              "&queryPager=" +
              encodeURIComponent(queryPagerStr) +
              "&criterion=" +
              encodeURIComponent(criterionStr),
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: vm.$localStorage.get("idb_login_token")
              }
            }
          )
          .then(function(response) {
            vm.ipArray = response.data.resultList;
            vm.ipArray.forEach(ip => {
              ip.caseDetail = vm.targetItem.interpreterCaseDetails.find(
                detail => {
                  return detail.memberId == ip.uuid;
                }
              );
            });
            vm.ipArray.forEach(element => {
              if (element.caseCount == null) {
                element.caseCount = 0;
              }
            });
            console.log("DDD \n" + JSON.stringify(response.data.resultList));

            //媒合中通譯人才排序
            if (vm.targetItem.status == "C01") {
              var filterStatusEqI01 = vm.ipArray.filter(function(item) {
                return item.caseDetail.status == "I01"; // 取得可服務
              });
              var filterStatusEqI00 = vm.ipArray.filter(function(item) {
                return item.caseDetail.status == "I00"; // 取得待通譯回覆
              });
              var filterStatusEqI02 = vm.ipArray.filter(function(item) {
                return item.caseDetail.status == "I02"; // 取得無法服務
              });
              vm.ipArray = [];
              vm.ipArray = vm.ipArray
                .concat(filterStatusEqI01)
                .concat(filterStatusEqI00)
                .concat(filterStatusEqI02);
            } else if (vm.targetItem.status == "C02") {
              var filterStatusEqI03 = vm.ipArray.filter(function(item) {
                return item.caseDetail.status == "I03"; // 取得待通譯確認
              });
              var filterStatusEqOthers = vm.ipArray.filter(function(item) {
                return item.caseDetail.status != "I03"; // 取得其他
              });
              vm.ipArray = [];
              vm.ipArray = vm.ipArray
                .concat(filterStatusEqI03)
                .concat(filterStatusEqOthers);
            } else if (
              vm.targetItem.status == "C03" ||
              vm.targetItem.status == "C04" ||
              vm.targetItem.status == "C06" ||
              vm.targetItem.status == "C07" ||
              vm.targetItem.status == "C08"
            ) {
              var filterStatusGtI04 = vm.ipArray.filter(function(item) {
                // 取得狀態不是「已有人選」
                return (
                  item.caseDetail.status >= "I04" &&
                  item.caseDetail.status != "I06"
                );
              });
              var filterStatusEqI06 = vm.ipArray.filter(function(item) {
                // 取得狀態為「已有人選」
                return item.caseDetail.status == "I06";
              });
              vm.ipArray = [];
              vm.ipArray = vm.ipArray
                .concat(filterStatusGtI04)
                .concat(filterStatusEqI06);
            } else if (
              vm.targetItem.status == "C05" ||
              vm.targetItem.status == "C09"
            ) {
              var filterStatusGroup1 = vm.ipArray.filter(function(item) {
                // 取得狀態3,4,5,7
                return (
                  item.caseDetail.status == "I03" ||
                  item.caseDetail.status == "I04" ||
                  item.caseDetail.status == "I05" ||
                  item.caseDetail.status == "I07"
                );
              });
              var filterStatusGroup2 = vm.ipArray.filter(function(item) {
                // 取得狀態1
                return item.caseDetail.status == "I01";
              });
              var filterStatusGroup3 = vm.ipArray.filter(function(item) {
                // 取得狀態0
                return item.caseDetail.status == "I00";
              });
              var filterStatusGroup4 = vm.ipArray.filter(function(item) {
                // 取得狀態2
                return item.caseDetail.status == "I02";
              });
              var filterStatusGroup5 = vm.ipArray.filter(function(item) {
                // 取得狀態6
                return item.caseDetail.status == "I06";
              });

              vm.ipArray = [];
              vm.ipArray = vm.ipArray
                .concat(filterStatusGroup1)
                .concat(filterStatusGroup2)
                .concat(filterStatusGroup3)
                .concat(filterStatusGroup4)
                .concat(filterStatusGroup5);
            }
          })
          .catch(function(error) {
            vm.handErrorUtil(error);
            console.log(error);
          });
      })
      .catch(function(error) {
        vm.handErrorUtil(error);
        console.log(error);
      });

    // vm.updateTargetCaseId("");
  },
  created() {
    let vm = this;
    Vue.SSE(
      vm.idbServerUrl + "idb/caseEvents?memberId=" +
        vm.userProfile.memberAccount.uuid,
      { format: "json" }
    )
      .then(sse => {
        msgServer = sse;

        sse.onError(e => {
          console.error("lost connection; giving up!", e);

          // This is purely for example; EventSource will automatically
          // attempt to reconnect indefinitely, with no action needed
          // on your part to resubscribe to events once (if) reconnected
          sse.close();
        });

        // Listen for messages without a specified event
        sse.subscribe("", itCase => {
          console.log("Received a message w/o an event!", itCase);
          if (vm.targetItem.caseNo == itCase.caseNo) {
            vm.ipArray.forEach(ip => {
              let responseCaseDetail = itCase.interpreterCaseDetails.find(
                detail => {
                  return detail.memberId == ip.uuid;
                }
              );
              if (responseCaseDetail != null) {
                if (ip.caseDetail.status != responseCaseDetail.status) {
                  if (
                    vm.isItemExist(ip.caseDetail) &&
                    responseCaseDetail.status != "I01"
                  ) {
                    vm.selectedArray.splice(
                      vm.findSelectedIndex(ip.caseDetail),
                      1
                    );
                  }
                  ip.caseDetail.status = responseCaseDetail.status;
                }

                console.log(responseCaseDetail.status);
              }
            });
          }
        });
      })
      .catch(err => {
        // When this error is caught, it means the initial connection to the
        // events server failed.  No automatic attempts to reconnect will be made.
        console.error("Failed to connect to server", err);
      });
  },
  beforeDestroy() {
    // Make sure to close the connection with the events server
    // when the component is destroyed, or we'll have ghost connections!
    msgServer.close();
  }
};
</script>
      
